// API базовый URL - используем бэкенд вместо прямого вызова OpenAI
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

/**
 * Sends a message to backend API and gets response
 * @param {string} userMessage - The user's input message
 * @param {Array} conversationHistory - Previous conversation context
 * @returns {Promise<string>} The AI assistant's response
 */
export async function getChatbotResponse(userMessage, conversationHistory = []) {
  try {
    const response = await fetch(`${API_BASE_URL}/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userMessage,
        conversationHistory,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.response;
  } catch (error) {
    console.error('Error getting chatbot response:', error);
    
    // Provide user-friendly error messages
    if (error.message.includes('401')) {
      throw new Error('API ключ недействителен. Пожалуйста, проверьте настройки сервера.');
    } else if (error.message.includes('429')) {
      throw new Error('Превышен лимит запросов. Попробуйте позже.');
    } else if (error.message.includes('API')) {
      throw new Error('Ошибка подключения к серверу. Попробуйте позже.');
    } else {
      throw new Error(error.message || 'Произошла ошибка при обработке запроса. Попробуйте еще раз.');
    }
  }
}

/**
 * Streams chatbot response chunk by chunk for real-time display
 * @param {string} userMessage - The user's input message
 * @param {Array} conversationHistory - Previous conversation context
 * @param {Function} onChunk - Callback function to handle each chunk
 */
export async function getStreamingChatbotResponse(userMessage, conversationHistory = [], onChunk) {
  try {
    const response = await fetch(`${API_BASE_URL}/chat/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userMessage,
        conversationHistory,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
      const { done, value } = await reader.read();
      
      if (done) break;

      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const data = line.slice(6);
          
          if (data === '[DONE]') {
            return;
          }

          try {
            const parsed = JSON.parse(data);
            if (parsed.content) {
              onChunk(parsed.content);
            } else if (parsed.error) {
              throw new Error(parsed.error);
            }
          } catch (e) {
            // Игнорируем ошибки парсинга
          }
        }
      }
    }
  } catch (error) {
    console.error('Error in streaming chatbot response:', error);
    throw error;
  }
}